export default __webpack_public_path__ + "static/media/hitch_bottom_gray.75ba3307.svg";